import React, { useEffect, useRef, useState } from "react";
import "./HorizontalScroll.scss";

const HorizontalScroll = ({ children }) => {
  const scrollable = useRef();
  const [scrollPosition, setScrollPosition] = useState({
    left: true,
    right: false,
  });
  const position = (element) => ({
    left: element.target.scrollLeft === 0,
    right:
      element.target.scrollWidth - element.target.scrollLeft ===
      element.target.clientWidth,
  });
  const handleScroll = (e) => {
    setScrollPosition(position(e));
  };
  useEffect(() => {
    const element = scrollable.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  const leftClass = scrollPosition.left ? "hide-left-fade" : "";
  const rightClass = scrollPosition.right ? "hide-right-fade" : "";
  return (
    <div className={`scrollable-container ${leftClass} ${rightClass}`}>
      <div className="scrollable-content" ref={scrollable}>
        {children}
      </div>
    </div>
  );
};
export default HorizontalScroll;
